// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:47:41

export default {
  "id": "bus-parking-out",
  "slug": "bus-parking-out",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ee798269399449d0b1acb60f81dff1fc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ee798269399449d0b1acb60f81dff1fc/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bus Parking Out",
      "description": "Logic meets strategy! Operate 3 types of buses in 8 vibrant colors, each requiring careful planning. Enjoy a stunning 3D environment, as you clear the way for the selected bus and collect passengers. Master the art of optimal movement.\n",
      "instructions": "Players move different colored buses placed in a parking lot, each with its own size and movement direction. The goal of the game is to clear paths to free the selected bus and collect matching passengers in the most efficient way possible.\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "bus",
        "busparking",
        "parking"
      ]
    },
    "zh-CN": {
      "title": "公交车停车场",
      "description": "逻辑与策略碰撞！操作3种不同类型的公交车，共有8种鲜艳的颜色，每种都需要精心规划。享受令人惊叹的3D环境，为你选择的公交车清障并收集乘客。掌握最优移动的艺术。",
      "instructions": "玩家需要移动停车场内放置的不同颜色的公交车，每辆公交车都有自己的大小和移动方向。游戏的目标是以最有效的方式清除路径，释放所选的公交车并收集匹配的乘客。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "公交车",
        "公交车停车场",
        "停车场"
      ]
    },
    "zh-TW": {
      "title": "巴士停車場外",
      "description": "邏輯碰觸策略！運營3種類的巴士，共有8種亮麗顏色，每種都需要謹慎規劃。享受令人驚艷的3D環境，當你為選定的巴士開闢道路並收穫乘客時。掌握最優移動的藝術。",
      "instructions": "玩家移動停車場中放置的不同顏色的巴士，每輛巴士都有其自身的尺寸和移動方向。遊戲的目標是清除路徑以釋放選定的巴士，並以最有效的方式收集匹配的乘客。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "巴士",
        "巴士停車場",
        "停車"
      ]
    },
    "zh-HK": {
      "title": "巴士停泊區",
      "description": "邏輯遇見策略！操縱3種類的巴士，共有8種鮮豔色彩，每種都需要謹慎規劃。享受壯觀的3D環境，清除選定巴士的道路，並收集乘客。掌握最佳移動的藝術。",
      "instructions": "玩家移動停車場內不同顏色的巴士，每輛巴士都有其獨特的尺寸和移動方向。遊戲的目標是清空道路以釋放選定的巴士，並以最有效率的方式收集匹配的乘客。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "巴士",
        "巴士停泊位",
        "停泊位"
      ]
    },
    "ja": {
      "title": "バス停め場外",
      "description": "ロジックと戦略が融合！8色の鮮やかなバスのうち、3種類を運営しながら慎重な計画を立てましょう。選択したバスの道を切り開き、乗客を収集しながら、驚くほどの3D環境を楽しみましょう。最適な動きの術を極めましょう。",
      "instructions": "プレイヤーは駐車場に配置された色とりどりのバスを動かし、それぞれの大きさと動き方を持っています。ゲームの目的は、選択したバスを解放し、最も効率的な方法で一致する乗客を収集するための道を開くことです。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "バス",
        "バス駐車",
        "駐車"
      ]
    },
    "ko": {
      "title": "버스 주차 공간",
      "description": "로직과 전략이 만나다! 8가지 다양한 색상의 3종류 버스를 운영하세요. 각 버스는 신중한 계획이 필요합니다. 선택한 버스를 통과시키고 승객을 모으는 동안 장관적인 3D 환경을 즐겨보세요. 최적의 이동 기술을 익혀보세요.",
      "instructions": "플레이어들은 주차장에 배치된 다양한 색상의 버스를 이동시키며, 각 버스는 자신만의 크기와 이동 방향을 가지고 있습니다. 게임의 목표는 선택된 버스를 해방시키고, 가장 효율적으로 일치하는 승객을 수집하는 것이입니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "버스",
        "버스주차",
        "주차"
      ]
    },
    "fr": {
      "title": "Parking de bus hors circuit",
      "description": "Logique et stratégie se rencontrent ! Opérez 3 types de bus dans 8 couleurs vibrantes, chacun nécessitant une planification soignée. Profitez d'un environnement 3D époustouflant, où vous dégager la voie pour le bus sélectionné et collectez les passagers. Maitrisez l'art du mouvement optimal.",
      "instructions": "Les joueurs déplacent des bus de couleurs différentes placés dans un parking, chacun ayant sa propre taille et direction de déplacement. Le but du jeu est de dégager des chemins pour libérer le bus sélectionné et recueillir les passagers correspondants de la manière la plus efficace possible.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "bus : autocar\nbusparking : stationnement pour autocars\nparking : parking"
      ]
    }
  }
};
